/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */

/**
 * User session interface.
 *
 * Represents a user session including a user (jwt) token and expiry.
 */
export interface UserSessionInterface {
    token: string;
    expiry: number;
}

/**
 * User session class.
 *
 * Concrete implementation of the UserSessionInterface.
 */
export class UserSession implements UserSessionInterface {
    public token: string = '';
    public expiry: number = 0;
}

/**
 * User session state interface.
 *
 * Note: at the moment no additional user information is required so our state only contains user session configuration.
 */
export interface UserSessionStateInterface {
    session: UserSessionInterface;
}

/**
 * User authentication session request interface.
 */
export interface UserAuthenticationRequestInterface {
    code: string;
}
